module.exports = __webpack_public_path__ + "static/media/griffith.d19c750e.png";